
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M198.2 283.6L27.6 454.2l30.2 30.2 170.7-170.7-30.3-30.1zM0 320v192h192v-42.7H42.7V320H0zM454.2 27.6L283.6 198.2l30.2 30.2L484.4 57.8l-30.2-30.2zM320 42.7h149.3V192H512V0H320v42.7z"}})])
          )
        }
      }
    